// Based on:
// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
// https://stackoverflow.com/a/9851769/2080504
//

import {Injectable} from '@angular/core';
import {Utils} from './utils/utils';

// START - Detect browser logic
//

// declaring these (implicitly) as any, so the debugger won't complain. Note, that this is JS logic anyway, not TS
declare var window;
declare var opr;
declare var document;
declare var safari;
declare var InstallTrigger;

// Opera 8.0+
var isOpera = (!!(window).opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
var isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
  return p.toString() === '[object SafariRemoteNotification]';
})(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

// Internet Explorer 6-11
var isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
var isEdge = !isIE && !!window.StyleMedia;

// Chrome 1+
var isChrome = !!window.chrome && !!window.chrome.webstore;

// Blink engine detection
var isBlink = (isChrome || isOpera) && !!window.CSS;
//
// END - Detect browser logic

@Injectable()
export class BrowserDetectorService {
  private _browserType: BrowserType = null;

  public get browserType() {
    if (this._browserType === null) {
      this._browserType = this._calcBrowserType();
    }
    return this._browserType;
  }

  private _calcBrowserType = () => {
    let browserType = BrowserType.Unknown;

    if (isOpera) {
      browserType = browserType | BrowserType.Opera;
    }
    if (isFirefox) {
      browserType = browserType | BrowserType.Firefox;
    }
    if (isSafari) {
      browserType = browserType | BrowserType.Safari;
    }
    if (isIE) {
      browserType = browserType | BrowserType.IE;
    }
    if (isEdge) {
      browserType = browserType | BrowserType.Edge;
    }
    if (isChrome) {
      browserType = browserType | BrowserType.Chrome;
    }
    if (isBlink) {
      browserType = browserType | BrowserType.Blink;
    }

    let result = BrowserType.isValid(browserType) ? browserType : BrowserType.Unknown;
    //console.log(`browserType: ${BrowserType[browserType]} (${browserType})`);
    //console.log(`result: ${BrowserType[result]} (${result})`);
    console.log(`Browser is determined as: ${BrowserType[result]} (${browserType})`);

    return result;
  };

  //#region Facade methods
  public get isOpera() {
    return BrowserType.isOpera(this.browserType);
  }

  public get isFirefox() {
    return BrowserType.isFirefox(this.browserType);
  }

  public get isSafari() {
    return BrowserType.isSafari(this.browserType);
  }

  public get isIE() {
    return BrowserType.isIE(this.browserType);
  }

  public get isEdge() {
    return BrowserType.isEdge(this.browserType);
  }

  public get isChrome() {
    return BrowserType.isChrome(this.browserType);
  }

  public get isBlink() {
    return BrowserType.isBlink(this.browserType);
  }

  //#endregion
}

export enum BrowserType {
  Unknown = 0,

  Opera = 1 << 0,   // 0000001
  Firefox = 1 << 1, // 0000010
  Safari = 1 << 2,  // 0000100
  IE = 1 << 3,      // 0001000
  Edge = 1 << 4,    // 0010000
  Chrome = 1 << 5,  // 0100000
  Blink = 1 << 6,   // 1000000
}

export namespace BrowserType {
  /**
   * Note: BrowserType.Unknown is considered invalid
   */
  export function isValid(browserType: BrowserType) {
    return Utils.local.isPowerOfTwo(browserType);
  }

  export function isOpera(browserType: BrowserType) {
    return browserType === BrowserType.Opera;
  }

  export function isFirefox(browserType: BrowserType) {
    return browserType === BrowserType.Firefox;
  }

  export function isSafari(browserType: BrowserType) {
    return browserType === BrowserType.Safari;
  }

  export function isIE(browserType: BrowserType) {
    return browserType === BrowserType.IE;
  }

  export function isEdge(browserType: BrowserType) {
    return browserType === BrowserType.Edge;
  }

  export function isChrome(browserType: BrowserType) {
    return browserType === BrowserType.Chrome;
  }

  export function isBlink(browserType: BrowserType) {
    return browserType === BrowserType.Blink;
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/shared/browser-detector.service.ts